import { patterns } from '@gem/utils';

import { ISymbolsHandler } from '../../../getSymbolsChecks.types';
import { getContentPositions } from '../../../utils/getContentPositions/getContentPositions';

const emailRegexp = new RegExp(patterns.EMAIL_ADDRESS);

export const handlerEmail: ISymbolsHandler = (opts) => {
  const { text, index, symbolMatches } = opts;
  const { startPosition, content } = getContentPositions(text, index);
  const matches = content.match(emailRegexp);

  if (matches && matches[0] && matches.index !== undefined) {
    symbolMatches.email.push({
      start: startPosition + matches.index,
      end: startPosition + matches.index + matches[0].length,
      email: matches[0],
    });
  }
};
